module.exports = __webpack_public_path__ + "img/header_img1.eae32e70.png";